import colors from '@atom/styles/colors';

import WeekViewDay from './WeekViewDay';
import WeekViewHeader from './WeekViewHeader';

interface Props {
  date: Date;
  datesOfWeek: Date[];
}

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    borderTop: `1px solid ${colors.neutral.ash}`,
    flex: 1,
  },
  dayColumns: {
    display: 'flex',
    flex: 1,
    borderBottom: `1px solid ${colors.neutral.ash}`,
  },
};

const WeekView = ({ datesOfWeek }: Props) => {
  return (
    <div style={styles.wrapper}>
      <WeekViewHeader datesOfWeek={datesOfWeek} />
      <div style={styles.dayColumns}>
        {datesOfWeek.map((day, idx) => (
          <WeekViewDay key={idx} day={day} first={idx === 0} />
        ))}
      </div>
    </div>
  );
};

export default WeekView;
